import React from 'react';
import styles from './Partners.module.css';

const PartnersPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        <div className={styles.header}>
          <h1 className={styles.title}>Partners</h1>
        </div>

        <div className={styles.messageBox}>
          <h2 className={styles.messageTitle}>We are Integrating with our Partners and soon update our web-Page.</h2>
        </div>

      </div>
    </div>
  );
};

export default PartnersPage;